

exports.__esModule = true;
exports.$AddShippingPageRoute = undefined;

var _squid = require('squid');

require('xo-member-components/src/select-shipping/add-shipping/route');

require('./directive');

var $AddShippingPageRoute = exports.$AddShippingPageRoute = _squid.$ComponentRoute.extend('$AddShippingPageRoute', {
    path: 'pageAddShipping',
    directive: 'xo-page-add-shipping-page',
    titleContent: 'addShipping.addAddress',
    query: ['message'],
    trackingData: {
        templateName: 'addShipping.dust',
        pageGoal: 'Add Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address-nonXB',
                'pagename2': '%::fullpage-add-shipping-address-nonXB:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token',
            'done-fn': 'callbacks.done',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$AddShippingPageRoute", $AddShippingPageRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-shipping/route.js
// module id = ./pages/xo-add-shipping/route.js
// module chunks = 0